import { validator } from '../core'

const EMAIL_REGX =
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/

export const emailValidation = () => {
  return validator
    .string()
    .required('Email is required')
    .matches(EMAIL_REGX, 'Invalid email address')
}
